import { render, staticRenderFns } from "./quarantine_facilities.vue?vue&type=template&id=b9004b36&"
import script from "./quarantine_facilities.vue?vue&type=script&lang=js&"
export * from "./quarantine_facilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports